import getWords from '../helpers/word/getWords.js';
import removeHtmlBlocks from '../helpers/html/htmlParser';
import {filterShortcodesFromHTML} from '../helpers';

/**
 * A result of the word count calculation.
 *
 * @typedef WordCountResult
 * @param {number} count The number of words found in the text.
 * @param {"word"} unit The unit used in the text length calculations, always "word".
 */

/**
 * Count the words in the text.
 *
 * @param {Paper} paper The Paper object.
 *
 * @param value
 * @returns {WordCountResult} The number of words found in the text, plus "word" as the unit used in calculating the text length.
 */
export default function(paper, value = null) {
  let text = typeof value === 'string' ? value : paper.getText();
  text = removeHtmlBlocks(text);
  text = filterShortcodesFromHTML(text, paper?._attributes && paper._attributes.shortcodes);
  // getWords strips only its own punctuation set, so "/" and "%" survive as tokens; a spec
  // list like "zout / Grasbrok" or "1.5 %" counted each one as a word. Customers judge the
  // 300-500 range by the app's editor counter, which already skips them (FAL-943).
  const count = getWords(text).filter(word => /[\p{L}\p{N}]/u.test(word)).length;
  return {
    text: text,
    count,
    unit: 'word'
  };
}
